<template>
	<!-- CART DROPDOWN -->
	<div>
		<feather-icon icon="GlobeIcon" class="cursor-pointer ml-4 mr-5 mt-1 text-white" badge="Geo" @click="show" />
	</div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import FormGeo from "@/components/zonification/FormGeo.vue";

export default {
	components: {
		VuePerfectScrollbar,
		FormGeo,
	},
	data() {
		return {
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			isGeo: false,
		};
	},
	computed: {
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
	},
	methods: {
		show() {
			this.$store.commit("moduleMap/TOGGLE_GEO", true);
		},
		copyResults() {
			this.$refs.FormGeo.copyResults();
		},
		geoAgain() {
			this.$refs.FormGeo.geoCoder();
		},
		dropdownClick(e) {
			this.isGeo = false;
		},
	},
};
</script>
<style lang="scss" scoped>
.feather-icon-badge {
	background: #323232 !important;
	padding-right: 13px;
	padding-left: 13px;
}
</style>
